import React from 'react';
import UserStore from '../stores/UserStore';
import { observer } from 'mobx-react';

const NoContactRelaterAlert = observer(() => {
    return (
        <div>
            There is no an account associated with {UserStore.user?.email} yet! Please contact to{' '}
            <a href="mailto:info.parts-badger.com" style={{ color: '#c00' }}>
                support.parts-badger.com
            </a>{' '}
            to help to you!
        </div>
    );
});

export default NoContactRelaterAlert;
